import { oc } from '@orpc/contract';
import { z } from 'zod';

/** 申請画面用: 証明書登録済みかつ e-Gov 連携済みプロファイルのみ */
const govProfileListItemSchema = z.object({
  profileId: z.string(),
  profileName: z.string(),
  isDefault: z.boolean()
});
const SubmittableGovProfilesOutputSchema = z.object({
  profiles: z.array(govProfileListItemSchema)
});
const submittableGovProfilesContract = oc.route({
  method: 'GET',
  path: '/v2/gov-profile/submittable'
}).input(z.object({})).output(SubmittableGovProfilesOutputSchema);
export type SubmittableGovProfileItem = z.infer<typeof govProfileListItemSchema>;
export const govProfileSubmittableContract = oc.router({
  list: submittableGovProfilesContract
});